import Vue from 'vue';
import VueRouter from 'vue-router';

// views
import HomeView from '../views/HomeView';
import GenchLoadingView from '../views/GenchLoadingView';
import LogoutView from '../views/LogoutView';
import HpuLoadingView from '../views/HpuLoadingView';
import NbdhyLoadingView from '../views/NbdhyLoadingView';
import SwcvcLoadingView from '../views/SwcvcLoadingView.vue';
import GroupLoadingView from '../views/GroupLoadingView.vue'
import HnshzyLoadingView from '../views/HnshzyLoadingView.vue'
import KmyesfLoadingView from '../views/KmyesfLoadingView.vue'

Vue.use(VueRouter);

export const constantRouterMap = [
    {
        path: '/',
        name: 'home',
        component: HomeView
    }, {
        path: '/thirdauth/gench',
        name: 'LoadingView',
        component: GenchLoadingView
    }, {
        path: '/thirdauth/gench/logout',
        component: LogoutView
    },
    {
        path: '/thirdauth/:school/:product/:action/:appId/:returnParam/:mttoken?',
        component: {
            functional: true,
            render(h, { parent, data }) {
                // console.log(parent.$route);
                const school = parent.$route.params.school;
                let component;
                switch (school) {
                    case 'hpu': // 河南理工大学
                        component = HpuLoadingView;
                        break;
                    case 'nbdhy': // 宁波财经学院
                        component = NbdhyLoadingView;
                        break;
                    case 'swcvc': // 四川水利职业技术学院
                        component = SwcvcLoadingView;
                        break;
                    case 'hnshzy': // 湖南石油化工职业技术学院
                        component = HnshzyLoadingView;
                        break;
                    case 'kmyesf': // 昆明幼儿师范
                        component = KmyesfLoadingView;
                        break;
                    case 'yngsxy': // 云南工商学院
                    case 'lutcte': // 兰州信息科技学院
                    case 'hhdu': // 哈尔滨华德学院
                    case 'ticgx': // 广西英华国际职业学院
                    case 'lykjxy': // 洛阳科技职业学院
                    case 'hbmykjxy': // 湖北恩施学院
                    case 'gzgszy': // 贵州工商职业学院
                    case 'zcu': // 郑州城市职业学院
                        component = GroupLoadingView;
                        break;
                    default:
                        console.log('unknown school');
                }
                return h(component, data, parent.$slots.default);
            }
        }
    },
    {
        path: '/thirdauth/:school/PORTAL',
        component: {
            functional: true,
            render(h, { parent, data }) {
                // console.log(parent.$route);
                const school = parent.$route.params.school;
                let component;
                switch (school) {
                    case 'hnshzy': // 湖南石油化工职业技术学院
                        component = HnshzyLoadingView;
                        break;
                    case 'kmyesf': // 昆明幼儿师范
                        component = KmyesfLoadingView;
                        break;
                    case 'yngsxy': // 云南工商学院
                    case 'lutcte': // 兰州信息科技学院
                    case 'hhdu': // 哈尔滨华德学院
                    case 'ticgx': // 广西英华国际职业学院
                    case 'lykjxy': // 洛阳科技职业学院
                    case 'hbmykjxy': // 湖北恩施学院
                    case 'gzgszy': // 贵州工商职业学院
                    case 'zcu': // 郑州城市职业学院
                        component = GroupLoadingView;
                        break;
                    default:
                        console.log('unknown school');
                }
                return h(component, data, parent.$slots.default);
            }
        }
    },
    {
        path: '/thirdauth/hnshzy',
        component: HnshzyLoadingView,
    },
    {
        // 这里是解析从 portal-web 点击使用学校账号密码登录的url
        path: '/thirdauth/kmyesf',
        component: KmyesfLoadingView,
    }
];

const router = new VueRouter({
    mode: 'history',
    routes: constantRouterMap,
});

export default router;
